<template>
  <div class="mx-auto mb-12 max-w-lg text-center">
    <SpamSvg class="w-64" />
    <p class="text-2xl text-dark">Besoin de solliciter d’autres graphistes pour votre projet ?</p>
    <p class="text-sm">Déposez gratuitement une annonce pour trouver des graphistes disponibles immédiatement.</p>
    <button class="btn btn-primary btn-lg mt-6" data-bs-dismiss="modal" @click="openFast">Déposer une annonce</button>
  </div>
</template>

<script setup>
import SpamSvg from './SpamSvg.vue'

function openFast() {
  const event = new CustomEvent('openFast', {
    detail: {
      userSignedIn: true
    }
  })

  document.dispatchEvent(event)
}
</script>
